<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            ORGANIZATION / Chart of Accounts (CoA)
          </div>

          <chart-of-accounts state="view"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartOfAccounts from "../../../components/settings/chartOfAccounts";
export default {
name: "coaView",
  components: {
    ChartOfAccounts

  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        text-align: left;
        justify-content: start;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
